export type IActionObject<T = any> = {
  type: string;
  value?: T;
};
type IActionCreator<T = any> = (value?: T) => IActionObject<T>;

export function typeActionCreator(type: string): IActionCreator<void> {
  return () => ({ type });
}

export function valueActionCreator<T>(type: string): IActionCreator<T> {
  return value => ({
    type,
    value,
  });
}
